module.exports = __webpack_public_path__ + "static/media/orddiktat-intro.f3c0278b.mp3";